'use strict';

var List = require("bs-platform/lib/js/list.js");
var Curry = require("bs-platform/lib/js/curry.js");
var $$String = require("bs-platform/lib/js/string.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");

function chunk(size, input) {
  var loop = function (_acc, _input) {
    while(true) {
      var input = _input;
      var acc = _acc;
      if (input === "") {
        return acc;
      } else if (input.length <= size) {
        return /* :: */[
                input,
                acc
              ];
      } else {
        var head = $$String.sub(input, 0, size);
        var remaining = input.length - size | 0;
        var tail = $$String.sub(input, size, remaining);
        _input = tail;
        _acc = /* :: */[
          head,
          acc
        ];
        continue ;
      }
    };
  };
  return List.rev(loop(/* [] */0, input));
}

function group_by_order(reverseOpt, predicate, items) {
  var reverse = reverseOpt !== undefined ? reverseOpt : false;
  if (items) {
    var _acc = /* [] */0;
    var _pin = items[0];
    var _res = /* [] */0;
    var _param = items[1];
    while(true) {
      var param = _param;
      var res = _res;
      var pin = _pin;
      var acc = _acc;
      if (param) {
        var tail = param[1];
        var head = param[0];
        if (Curry._2(predicate, head, pin)) {
          _param = tail;
          _pin = head;
          _acc = /* :: */[
            head,
            acc
          ];
          continue ;
        } else {
          _param = tail;
          if (reverse) {
            _res = /* :: */[
              Pervasives.$at(acc, /* :: */[
                    pin,
                    /* [] */0
                  ]),
              res
            ];
            _pin = head;
            _acc = /* [] */0;
            continue ;
          } else {
            _res = Pervasives.$at(res, /* :: */[
                  /* :: */[
                    pin,
                    acc
                  ],
                  /* [] */0
                ]);
            _pin = head;
            _acc = /* [] */0;
            continue ;
          }
        }
      } else if (reverse) {
        return /* :: */[
                Pervasives.$at(acc, /* :: */[
                      pin,
                      /* [] */0
                    ]),
                res
              ];
      } else {
        return Pervasives.$at(res, /* :: */[
                    /* :: */[
                      pin,
                      acc
                    ],
                    /* [] */0
                  ]);
      }
    };
  } else {
    return /* [] */0;
  }
}

function take(size, input) {
  var loop = function (input, size) {
    if (input && size !== 0) {
      return /* :: */[
              input[0],
              loop(input[1], size - 1 | 0)
            ];
    } else {
      return /* [] */0;
    }
  };
  return loop(input, size);
}

function drop(size, input) {
  var _input = input;
  var _size = size;
  while(true) {
    var size$1 = _size;
    var input$1 = _input;
    if (input$1 && size$1 !== 0) {
      _size = size$1 - 1 | 0;
      _input = input$1[1];
      continue ;
    } else {
      return input$1;
    }
  };
}

function chunk_list(size, input) {
  var loop = function (_acc, _list) {
    while(true) {
      var list = _list;
      var acc = _acc;
      if (List.length(list) <= size) {
        return /* :: */[
                list,
                acc
              ];
      } else {
        var elem = take(size, list);
        _list = drop(size, list);
        _acc = /* :: */[
          elem,
          acc
        ];
        continue ;
      }
    };
  };
  return List.rev(loop(/* [] */0, input));
}

exports.chunk = chunk;
exports.group_by_order = group_by_order;
exports.take = take;
exports.drop = drop;
exports.chunk_list = chunk_list;
/* No side effect */
